<template>
    <div class="bg-slate-700">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'GuestLayout'
}
</script>
